import React from "react";
import { Link } from "react-router-dom";
import { Money, Time, Parcel, Layananimg2, Lawfirm, Legalbisnis, Agro, Aboutusimg } from "../assets/images";
import { FaPeopleGroup } from "react-icons/fa6";

function Layanantransport() {
  return (
    <div className="md:pt-12 pt-14">
        <h1> Ini layanan Transportasi dan Logistik</h1>
    </div>
  );
}

export default Layanantransport;
